(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("9Fxp1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2d37c224ffe1303b$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $5J7FU = parcelRequire("5J7FU");

const $2d37c224ffe1303b$var$ProjectObjectsTable = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("8bixH")));
const $2d37c224ffe1303b$var$ObjectTables = ()=>{
    const { estate: office } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    const tableTitle = office?.housingCooperatives && office?.housingCooperatives?.length > 0 ? (0, $5J7FU.ForSaleStrings).Estates : office?.houses && office?.houses.length > 0 || office?.housingCooperatives && office?.housingCooperatives?.length > 0 ? "Villor" : office?.plots && office?.plots.length > 0 ? "Tomter" : (0, $5J7FU.ForSaleStrings).Estates;
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            (office?.housingCooperatives && office?.housingCooperatives?.length > 0 || office?.houses && office?.houses.length > 0 || office?.housingCooperatives && office?.housingCooperatives?.length > 0 || office?.cottages && office?.cottages.length > 0 || office?.plots && office?.plots.length > 0) && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "m-auto px-0 lg:px-4 xxl:px-10",
                children: /*#__PURE__*/ (0, $a9eYm.jsxs)("h2", {
                    className: "font-icb text-2xl lg:text-3xl mb-4 lg:mb-6",
                    children: [
                        tableTitle,
                        " i projektet"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $dTCkE.Suspense), {
                children: [
                    office?.housingCooperatives && office?.housingCooperatives?.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)($2d37c224ffe1303b$var$ProjectObjectsTable, {
                        projects: office?.housingCooperatives,
                        type: "housingCooperatives"
                    }),
                    office?.houses && office?.houses.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)($2d37c224ffe1303b$var$ProjectObjectsTable, {
                        projects: office?.houses,
                        type: "houses"
                    }),
                    office?.plots && office?.plots.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)($2d37c224ffe1303b$var$ProjectObjectsTable, {
                        projects: office?.plots,
                        type: "plots"
                    }),
                    office?.cottages && office?.cottages.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)($2d37c224ffe1303b$var$ProjectObjectsTable, {
                        projects: office?.cottages,
                        type: "cottages"
                    })
                ]
            })
        ]
    });
};
var $2d37c224ffe1303b$export$2e2bcd8739ae039 = $2d37c224ffe1303b$var$ObjectTables;

});
parcelRegister("8bixH", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hrPkb")).then(()=>parcelRequire("izjN1"));

});


})();
//# sourceMappingURL=ObjectTables.e976927f.js.map
